// extracted by mini-css-extract-plugin
export default {"wrapper":"InGameLoadoutIcon-m_wrapper-wB2_9gw5","index":"InGameLoadoutIcon-m_index-Q6FVQlCA","iconImg":"InGameLoadoutIcon-m_iconImg-_Y1oSarh"};